
import React from 'react';
import { Anchor, Box, ResponsiveContext, Tab, Tabs, Text } from 'grommet';

import DataDoesNotExist from './common/DataDoesNotExist';
import OdrudyTratGraf from './trat/OdrudyTratGraf';
import OdrudyTratTable from './trat/OdrudyTratTable';
import VyhodnoceniValueMeters from './trat/VyhodnoceniValueMeters';
import ShowInMapLink from './map/ShowInMapLink';

const PropertyRow = ({title, value, link}) => {
    return (
        <Box direction="row">
            <Box flex="grow">
                <Text size="medium">{title}:</Text>
            </Box>
            <Box>
                {link && <Anchor size="medium" href={`#/${link}`} label={value} />}
                {!link && <Text size="medium" weight="bold">{value}</Text>}
            </Box>
        </Box>
    );
}

const SectionOdrudyGraf = ({tratDetail}) => {
    return (
        <Box>
            {(tratDetail.data.content.length > 0)
                ? (
                    <ResponsiveContext.Consumer>
                        {windowSize => {
                            return <OdrudyTratGraf tratContent={tratDetail.data.content} windowSize={windowSize} />;
                        }}
                    </ResponsiveContext.Consumer>
                )
                : <DataDoesNotExist />
            }
        </Box>
    );
}

const SectionOdrudyTable = ({tratDetail}) => {
    return (
        <Box>
            {(tratDetail.data.content.length > 0)
                ? <OdrudyTratTable tratContent={tratDetail.data.content} />
                : <DataDoesNotExist />
            }
        </Box>
    );
}

const SectionOverview = ({tratDetail}) => {
    const ATTRS = [
        ['Název tratě', 'trat', 'trat_lnk'],
        ['Katastrální území', 'katastr', 'katast_lnk'],
        ['Vinařská obec', 'obec'],
        ['Vinařská podoblast', 'podoblast', 'podobl_lnk'],
        ['Vinařská oblast', 'oblast']
    ];
    return ATTRS.map((item, index) => {
        let link = (item[2])
            ? tratDetail.data.attributes[item[2]]
            : null;
        return (
            <PropertyRow
                key={index}
                title={item[0]}
                value={tratDetail.data.attributes[item[1]]}
                link={link}
            />
        );
    });
}

const SectionVyhodnoceni = ({tratDetail}) => {
    return (
        <Box>
            {(tratDetail.data.vyhodnoceni.length > 0)
                ? <VyhodnoceniValueMeters tratVyhodnoceni={tratDetail.data.vyhodnoceni[0]} />
                : <DataDoesNotExist />
            }
        </Box>
    );
}

const TratDetail = ({tratDetail, setMapPoints}) => {
    return (
        <Box gap="medium">
            <SectionOverview tratDetail={tratDetail} />
            <Tabs justify="start">
                <Tab title="Management produkce">
                    <Box pad={{top: '12px'}}>
                        <SectionVyhodnoceni tratDetail={tratDetail} />
                    </Box>
                </Tab>
                <Tab title="Odrůdová skladba tratí (tabulka)">
                    <Box pad={{top: '12px'}}>
                        <SectionOdrudyTable tratDetail={tratDetail} />
                    </Box>
                </Tab>
                <Tab title="Odrůdová skladba tratí (graf)">
                    <Box pad={{top: '12px'}}>
                        <SectionOdrudyGraf tratDetail={tratDetail} />
                    </Box>
                </Tab>
            </Tabs>
            <ShowInMapLink
                points={[
                    {
                        x: tratDetail.data.attributes['x'],
                        y: tratDetail.data.attributes['y'],
                        title: tratDetail.data.attributes['trat'],
                    }
                ]}
                setMapPoints={setMapPoints}
            />
        </Box>
    );
}

export default TratDetail;
